import { gql } from '@anyx/common-graphql';

export const GENERATE_ASSET_UPLOAD_URL_V2 = gql(/* GraphQL */ `
  mutation GenerateAssetUploadUrlV2($input: GenerateAssetUploadUrlRequest!) {
    GenerateAssetUploadUrlV2(input: $input) {
      originalUrl {
        url
      }
    }
  }
`);

export const GENERATE_TRACKING_URL = gql(/* GraphQL */ `
  mutation GenerateTrackingUrl($input: GenerateTrackingUrlRequest!) {
    GenerateTrackingUrl(input: $input) {
      originalUrl
      trackingUrl
      shortUrl
    }
  }
`);
